import { useState } from 'react';
import InventariosList from './List.jsx';
import InventarioForm from './Form.jsx';
import InventarioDetail from './Detail.jsx';

export default function InventariosPage() {
  const [view, setView] = useState('list');
  const [selectedId, setSelectedId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = () => setRefreshKey((value) => value + 1);

  const handleBack = () => {
    setView('list');
    setSelectedId(null);
    refresh();
  };

  const handleSaved = () => {
    setView('list');
    setSelectedId(null);
    refresh();
  };

  if (view === 'create') {
    return <InventarioForm onCancel={handleBack} onSaved={handleSaved} />;
  }

  if (view === 'detail' && selectedId) {
    return <InventarioDetail inventarioId={selectedId} onBack={handleBack} />;
  }

  return (
    <InventariosList
      refreshKey={refreshKey}
      onCreate={() => {
        setSelectedId(null);
        setView('create');
      }}
      onSelect={(id) => {
        setSelectedId(id);
        setView('detail');
      }}
    />
  );
}
